import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    id: 0,
    show: false,
    message: '',
    variant: 'success',
    silent: false
  });

  // options.silent: Toast bleibt sichtbar, wird aber nicht in die Live-Region gesprochen (die Seite sagt selbst an).
  const showSuccessToast = useCallback((message, options) => {
    setToast(prev => ({
      id: prev.id + 1,
      show: true,
      message,
      variant: 'success',
      silent: Boolean(options?.silent)
    }));
  }, []);

  const showErrorToast = useCallback((message, options) => {
    setToast(prev => ({
      id: prev.id + 1,
      show: true,
      message,
      variant: 'danger',
      silent: Boolean(options?.silent)
    }));
  }, []);

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, show: false }));
  }, []);

  const value = useMemo(() => ({
    showSuccessToast, showErrorToast, toast, hideToast
  }), [showSuccessToast, showErrorToast, toast, hideToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};
